'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var useDateField = require('./useDateField.js');
var dateTimeFieldContext = require('../dateTimeFieldContext.js');
var DateSegment = require('../DateSegment/DateSegment.js');
require('react-aria');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["className"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Date field
 *
 * Allows users to enter past, present or future dates in various formats.
 */
var DateField = function DateField(props, ref) {
  var styles = react.useMultiStyleConfig('DateField', props);
  var _omitThemingProps = react.omitThemingProps(props),
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  var _split = utils.split(rest, react.layoutPropNames),
    _split2 = _slicedToArray__default["default"](_split, 2),
    layoutProps = _split2[0],
    otherProps = _split2[1];
  var inputRef = React.useRef();
  var _useDateField = useDateField.useDateField(otherProps, inputRef),
    getHtmlProps = _useDateField.getHtmlProps,
    context = _useDateField.context;
  var rootStyles = _objectSpread({
    width: '100%'
  }, styles.root);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    className: utils.cx('chakra-date-field', className)
  }, getHtmlProps(layoutProps, ref), {
    "aria-disabled": props.isDisabled,
    __css: rootStyles
  }), /*#__PURE__*/React__default["default"].createElement(dateTimeFieldContext.DateTimeFieldStylesProvider, {
    value: styles
  }, /*#__PURE__*/React__default["default"].createElement(dateTimeFieldContext.DateTimeFieldProvider, {
    value: context
  }, context.state.segments.map(function (segment, i) {
    return /*#__PURE__*/React__default["default"].createElement(DateSegment.DateSegment, {
      key: i,
      segment: segment
    });
  }))));
};
var _DateField = /*#__PURE__*/React__default["default"].forwardRef(DateField);

// https://github.com/mobxjs/mobx-react/issues/352#issuecomment-341861198
_DateField.displayName = 'DateField';
exports.DateField = _DateField;